import { render, staticRenderFns } from "./EditBL.vue?vue&type=template&id=1bdf85a0&scoped=true&lang=html&"
import script from "./EditBL.vue?vue&type=script&lang=js&"
export * from "./EditBL.vue?vue&type=script&lang=js&"
import style0 from "./EditBL.vue?vue&type=style&index=0&id=1bdf85a0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdf85a0",
  null
  
)

export default component.exports